var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { X } from 'react-feather';
import { FormProvider, useForm } from 'react-hook-form';
import { RoleCategories } from '../../../../application/common/constants/role-categories';
import { FileErrorType } from '../../../../application/common/enums/file-error-type';
import { useCreateMachineDocumentMutation } from '../../../../application/features/machine-documents/machine-document-api';
import { useGetActiveMachinesListQuery } from '../../../../application/features/machines/machine-api';
import { useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import AddDocuments from './AddDocuments';
import './style.scss';
var AddDocument = function (_a) {
    var open = _a.open, onClose = _a.onClose, _b = _a.initialFiles, initialFiles = _b === void 0 ? [] : _b;
    var translate = useTranslate().translate;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var isSuperAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin;
    var _c = __read(useState({
        hasError: false,
        errorType: FileErrorType.NoError
    }), 2), fileError = _c[0], setFileError = _c[1];
    var _d = useGetActiveMachinesListQuery({
        companyId: isSuperAdmin ? undefined : currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id,
        filterByCompany: true
    }).data, machines = _d === void 0 ? [] : _d;
    var _e = __read(useCreateMachineDocumentMutation(), 2), createDocuments = _e[0], createDocumentsLoading = _e[1].isLoading;
    var isLoading = createDocumentsLoading;
    var isMobileScreen = useMediaQuery('(max-width:600px)');
    var createDocumentForm = useForm({
        defaultValues: {
            machineId: '',
            modelNumber: '',
            modelNumberCreated: false,
            files: []
        }
    });
    var closeDialog = function () {
        onClose();
    };
    var handleSubmit = function () {
        createDocumentForm.handleSubmit(function (documents) {
            createDocuments(documents);
            onClose();
        })();
    };
    var files = createDocumentForm.watch('files');
    var calculateTotalSize = function () {
        if (!files || files.length === 0)
            return '0 MB';
        var totalBytes = files.reduce(function (acc, fileData) { return acc + fileData.file.size; }, 0);
        var totalMB = totalBytes / 1024 / 1024;
        if (totalMB >= 1) {
            return "".concat(totalMB.toFixed(2), " MB");
        }
        else {
            var totalKB = totalBytes / 1024;
            return "".concat(totalKB.toFixed(2), " KB");
        }
    };
    return (_jsxs(Dialog, { sx: { borderRadius: '44px' }, fullWidth: true, scroll: 'paper', open: open, maxWidth: 'sm', children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px'
                }, children: [translate('knowledge.uploadFilesDialog.title'), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: closeDialog, children: _jsx(X, { size: 20, color: '#637381' }) })] }), _jsx(DialogContent, { dividers: true, sx: {
                    pb: 4,
                    px: 4
                }, children: _jsx(FormProvider, __assign({}, createDocumentForm, { children: _jsx(AddDocuments, { machines: machines, filteredMachines: machines, initialFiles: initialFiles, onFileError: function (hasError, errorType) {
                            setFileError({ hasError: hasError, errorType: errorType });
                        } }) })) }), _jsxs(DialogActions, { sx: {
                    justifyContent: 'space-between',
                    px: 3,
                    py: 2,
                    flexDirection: isMobileScreen ? 'column' : 'row',
                    gap: isMobileScreen ? 1 : 0
                }, children: [_jsx(Box, { width: isMobileScreen ? '100%' : 'auto', children: files && files.length > 0 && (_jsxs(Typography, { variant: 'body2', ml: isMobileScreen ? 1 : 0, color: 'text.secondary', children: [translate('knowledge.uploadFilesDialog.total'), " ", calculateTotalSize()] })) }), _jsxs(Box, { display: 'flex', gap: 1, width: isMobileScreen ? '100%' : 'auto', children: [_jsx(Button, { disabled: isLoading, size: 'medium', fullWidth: isMobileScreen, onClick: closeDialog, variant: 'outlined', color: 'inherit', children: translate('actions.cancel') }), _jsx(Button, { disabled: isLoading ||
                                    fileError.errorType === FileErrorType.SizeError ||
                                    fileError.errorType === FileErrorType.TotalSizeError, size: 'medium', variant: 'contained', fullWidth: isMobileScreen, color: 'inherit', onClick: handleSubmit, children: files && files.length > 0
                                    ? translate('knowledge.uploadFilesDialog.uploadWithCount', {
                                        count: files.length
                                    })
                                    : translate('knowledge.uploadFilesDialog.upload') })] })] })] }));
};
export default AddDocument;
